import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

// Constants
import { EMBEDDED } from '../constants/build'
import { positioningTypes } from '../constants/display'

// Components
import ListingLaunchPad from './ListingLaunchPad'
import { LaunchPadRibbon } from './ListingLaunchPad/LaunchTargets'
import { LaunchPadRibbonProps } from './ListingLaunchPad/LaunchTargets/LaunchPadRibbon/LaunchPadRibbon'

interface ChromebotProps {
  clientAuthToken: string
  customerPublicKey: string
  customerProfileId: string
  address: string
  listingPrice: number
  positioning?: string
  className?: string
  amplitudeInstance?: any // TODO not pull from dist
}

const Chromebot = (props: ChromebotProps): JSX.Element => {
  const {
    clientAuthToken,
    customerPublicKey,
    customerProfileId,
    address,
    listingPrice,
    positioning,
    amplitudeInstance,
  } = props
  const launcher = useCallback(
    ({ className, id, handleClick }: LaunchPadRibbonProps) => (
      <LaunchPadRibbon
        className={className}
        id={id}
        handleClick={handleClick}
      />
    ),
    []
  )

  return (
    <ListingLaunchPad.Interface
      // Implementation Type
      widgetMode={EMBEDDED}
      // Auth Props
      customerProfileId={customerProfileId}
      clientAuthToken={clientAuthToken}
      customerPublicKey={customerPublicKey}
      // Behavior Props
      address={address}
      listingPrice={listingPrice}
      // Pass ampli instance in as props, can't read from qautermaster currently
      amplitudeInstance={amplitudeInstance}
    >
      <ListingLaunchPad launcher={launcher} positioning={positioning} />
    </ListingLaunchPad.Interface>
  )
}

Chromebot.propTypes = {
  listingPrice: PropTypes.number,
  address: PropTypes.string,
  clientAuthToken: PropTypes.string,
  customerPublicKey: PropTypes.string.isRequired,
  customerProfileId: PropTypes.string.isRequired,
  positioning: PropTypes.oneOf([
    positioningTypes.FIXED_RIGHT,
    positioningTypes.RELATIVE,
  ]),
  className: PropTypes.string,
  amplitudeInstance: PropTypes.object,
}

export default Chromebot
